import { onBeforeUnmount, watch, type Ref } from 'vue';

let lockCount = 0;

function canUseDOM() {
  return typeof document !== 'undefined';
}

export function lockBodyScroll() {
  if (!canUseDOM()) return;
  lockCount += 1;
  if (lockCount === 1) {
    document.body.style.overflow = 'hidden';
  }
}

export function unlockBodyScroll() {
  if (!canUseDOM()) return;
  if (lockCount > 0) {
    lockCount -= 1;
  }
  if (lockCount === 0) {
    document.body.style.overflow = '';
  }
}

export function useBodyScrollLock(source: Ref<boolean> | (() => boolean)) {
  let isLocked = false;
  const read = typeof source === 'function' ? source : () => source.value;

  watch(
    read,
    (value) => {
      if (value && !isLocked) {
        lockBodyScroll();
        isLocked = true;
        return;
      }
      if (!value && isLocked) {
        unlockBodyScroll();
        isLocked = false;
      }
    },
    { immediate: true },
  );

  onBeforeUnmount(() => {
    if (isLocked) {
      unlockBodyScroll();
      isLocked = false;
    }
  });
}
